import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categoriesInput", "dateFrom", "dateTo", "submitButton"]

  connect() {
    this.updateSubmitState()

    // Listen to category clicks to revalidate (category controller updates the hidden input)
    this.boundValidate = this.delayedValidate.bind(this)
    this.element.addEventListener("click", this.boundValidate)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundValidate)
  }

  validate() {
    this.updateSubmitState()
  }

  // Small delay to let the category controller update the hidden input first
  delayedValidate() {
    requestAnimationFrame(() => this.updateSubmitState())
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return

    const hasCategories = this.hasCategoriesInputTarget && this.categoriesInputTarget.value.trim() !== ""
    const hasDateFrom = this.hasDateFromTarget && this.dateFromTarget.value.trim() !== ""
    const hasDateTo = this.hasDateToTarget && this.dateToTarget.value.trim() !== ""

    if (hasCategories && hasDateFrom && hasDateTo) {
      this.submitButtonTarget.removeAttribute("disabled")
    } else {
      this.submitButtonTarget.setAttribute("disabled", "disabled")
    }
  }
}
